import * as Styled from './CreatePollPage.styles'
import {
  FormBuilder,
  PageContainer,
  PollQuestionInput,
  PublishBar,
} from '../../components'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import LoadingModal from '../../modals/LoadingModal/LoadingModal'
import { createNewPollForEvent } from '../../services/appsync'
import { ulid } from 'ulid'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'

const CreatePollPage = () => {
  const location = useLocation()
  const data = location.state
  const passedEventId = data.passedEventId as string

  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState('')
  const [fieldsCompleted, setFieldsCompleted] = useState(false)

  const formMethods = useForm({
    defaultValues: {
      pollQuestion: { question: '' },
      pollAnswers: [
        { id: ulid(), answer: '' },
        { id: ulid(), answer: '' },
      ],
    },
    mode: 'onChange',
  })

  const formValues = formMethods.watch()

  const userEmail = useSelector((state: RootState) => state.user.email)

  useEffect(() => {
    var questionCompleted = !(
      formMethods.getValues('pollQuestion.question').trim().length === 0
    )
    var answersCompleted = !(
      formMethods.getValues('pollAnswers').length !== 0 &&
      formMethods
        .getValues('pollAnswers')
        .some((answer: any) => answer.answer.trim().length === 0)
    )

    setFieldsCompleted(questionCompleted && answersCompleted)
  }, [formValues, formMethods])

  const createNewPollForThisEvent = async (eventId: string) => {
    try {
      setLoading(true)
      setLoadingMessage('Creating poll...')
      await createNewPollForEvent(
        eventId,
        userEmail,
        formMethods.getValues('pollQuestion.question'),
        formMethods.getValues('pollAnswers'),
      )

      navigate(-1) // Go back one page
    } catch (error) {
      console.error('Error creating poll: ', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingModal
        open={loading}
        onClose={() => setLoading(false)}
        message={loadingMessage}
      />
      <PageContainer>
        <Styled.PaddedContainer>
          <Styled.PageTitle display="flex">Create a Poll</Styled.PageTitle>
          <Styled.PollContainer>
            <Styled.PollInstructions>
              Fill out the details of the poll, then save. When you’re ready to
              push this poll to attendees, you can do so from the Live Event
              page or from the Manage Events page under the Upcoming tab.
            </Styled.PollInstructions>
            <Styled.PollInstructionsSubtitle>
              Polls can only contain one multiple choice quesiton, where only
              one answer can be selected by attendees answering.
            </Styled.PollInstructionsSubtitle>
            <PollQuestionInput control={formMethods.control} />
            <FormBuilder
              control={formMethods.control}
              formName="pollAnswers"
              isPollPage={true}
              placeholder="Enter answer option..."
            />
          </Styled.PollContainer>
        </Styled.PaddedContainer>
        <PublishBar
          onClear={() =>
            formMethods.reset({
              pollQuestion: { question: '' },
              pollAnswers: [
                { id: ulid(), answer: '' },
                { id: ulid(), answer: '' },
              ],
            })
          }
          onSave={() => createNewPollForThisEvent(passedEventId)}
          saveDisabled={!fieldsCompleted}
        />
      </PageContainer>
    </>
  )
}

export default CreatePollPage
